import React from 'react';
import PropTypes from 'prop-types'

class Tag extends React.PureComponent {
    getClassName() {
        const { className, theme } = this.props;
        const propsClassNameList = className.split(' ');
        const defaultClassNameList = [
            'custom-tag',
            `custom-tag-theme-${ theme }`
        ];

        return [ ...defaultClassNameList, ...propsClassNameList ].join(' ');
    }

    render() {
        const { size, value, fontSize, testid } = this.props;

        return (
            <div className={ this.getClassName() } style={{ width: size, height: size }} testid={testid ? testid : ''}>
                <span className="custom-tag-value" style={{ fontSize }}>{ value }</span>
            </div>
        );
    }
}

Tag.propTypes = {
    size: PropTypes.PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
    theme: PropTypes.oneOf(['black', 'red']),
    fontSize: PropTypes.string
};

Tag.defaultProps = {
    className: '',
    theme: 'black',
    fontSize: '0.9rem'
};

export default Tag;
